export const liveExchangeRatesSettings = {
  dots: true,
  customPaging: (i: number) => (
    <div
      // style={{
      //   position: 'absolute',
      //   width: '100%',
      //   top: '-6px',
      //   opacity: '0',
      // }}
      className="dg_testimonial-settings"
    >
      {i + 1}
    </div>
  ),
  dotsClass: 'prizes-dots',
  mobileFirst: true,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 2000,
  slidesToShow: 4.2,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: false,
  autoplay: true,
  swipeToSlide: true,
  pauseOnHover: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.0,
        slidesToScroll: 1,
        initialSlide: 2,
        infinite: true,
        dots: true,
      },
    },

    {
      breakpoint: 600,
      settings: {
        initialSlide: 1,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.0,
        slidesToScroll: 1,
        initialSlide: 2,
        infinite: true,
        dots: true,
      },
    },
  ],
};
